import { ReactNode } from "react";
import { cn } from "../../../utils/class-names";
import { DashboardMarketAsset } from "@silo/types";
import { TokenContext } from "../../token-context";

interface PillContainerProps {
  className?: string;
  children?: ReactNode;
}

export function PillContainer({
  className,
  children,
}: PillContainerProps): JSX.Element {
  return (
    <div className={cn("flex gap-2.5 flex-wrap @[1350px]:flex-[2]", className)}>
      {children}
    </div>
  );
}

interface TokenPillProps {
  className?: string;
  asset: DashboardMarketAsset;
  tokenLogo: ReactNode;
}

export function TokenPill({
  className,
  asset,
  tokenLogo,
}: TokenPillProps): JSX.Element {
  const { chainKey, tokenAddress, symbol } = asset;

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-lg bg-shale-750 px-5 py-2.5",
        className
      )}
    >
      <div>
        <TokenContext.Provider value={{ chainKey, tokenAddress }}>
          {tokenLogo}
        </TokenContext.Provider>
      </div>

      <div data-cy="symbol" className="font-medium text-white">
        {symbol}
      </div>
    </div>
  );
}

interface PositionTypePillProps {
  className?: string;
  children?: ReactNode;
}

export function PositionTypePill({
  className,
  children,
}: PositionTypePillProps): JSX.Element {
  return (
    <div
      className={cn(
        "rounded-lg bg-shale-750 px-5 py-2.5 font-medium self-stretch flex flex-col justify-center",
        className
      )}
    >
      {children}
    </div>
  );
}
